import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import { ORDER_KEY } from "./keys";

import { OrderRepository } from "@/repositories/order";

export const useRescheduleDelivery = () => {
  const queryClient = useQueryClient();
  const orderRepository = useRef(new OrderRepository());

  return useMutation({
    mutationFn: async ({
      orderId,
      deliveryDate,
    }: {
      orderId: string;
      deliveryDate: string;
    }) => {
      return orderRepository.current.rescheduleDelivery(orderId, deliveryDate);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ORDER_KEY] });
    },
  });
};
